const LEAD_CAPTURED_KEY = 'curelo_otp_lead_captured';
const LEAD_CAPTURED_TTL_MS = 30 * 60 * 1000; // align with max OTP session window

export const markLeadCaptured = (phone, leadId) => {
  try {
    const normalized = String(phone || '').replace(/\D/g, '');
    if (!normalized) return;
    sessionStorage.setItem(
      LEAD_CAPTURED_KEY,
      JSON.stringify({ phone: normalized, at: Date.now(), leadId: leadId || null })
    );
  } catch {
    // sessionStorage unavailable
  }
};

// The gateway's leadId for the currently-captured phone, so /api/otp/verify
// can PATCH the same lead instead of the backend falling back to a fresh
// submission. Returns null if nothing captured, expired, or for a different phone.
export const getCapturedLeadId = (phone) => {
  try {
    const normalized = String(phone || '').replace(/\D/g, '');
    if (!normalized) return null;

    const raw = sessionStorage.getItem(LEAD_CAPTURED_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.phone || parsed.phone !== normalized) return null;
    if (Date.now() - Number(parsed.at) > LEAD_CAPTURED_TTL_MS) return null;

    return parsed.leadId || null;
  } catch {
    return null;
  }
};

export const isLeadCapturedForPhone = (phone) => {
  try {
    const normalized = String(phone || '').replace(/\D/g, '');
    if (!normalized) return false;

    const raw = sessionStorage.getItem(LEAD_CAPTURED_KEY);
    if (!raw) return false;

    const parsed = JSON.parse(raw);
    if (!parsed?.phone || parsed.phone !== normalized) return false;

    if (Date.now() - Number(parsed.at) > LEAD_CAPTURED_TTL_MS) {
      sessionStorage.removeItem(LEAD_CAPTURED_KEY);
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export const clearLeadCaptured = (phone) => {
  try {
    const normalized = String(phone || '').replace(/\D/g, '');
    const raw = sessionStorage.getItem(LEAD_CAPTURED_KEY);
    if (!raw) return;

    const parsed = JSON.parse(raw);
    if (!phone || parsed?.phone === normalized) {
      sessionStorage.removeItem(LEAD_CAPTURED_KEY);
    }
  } catch {
    // ignore
  }
};
